import React, { useState } from 'react';
import ManageUserRow from '../molecules/ManageUserRow';
import { User, UserDetails } from '../types/User';
import '../../static/css/ManageUsers.css'
import { toast } from 'react-toastify';
import ConfirmDialog from '../atoms/ConfirmDialog';

interface ManageUserTableProps {
  users: User[];
  setUsers: React.Dispatch<React.SetStateAction<UserDetails[]>>;
  onUserStatusChange: (userId: number, newStatus: string) => void;
  roleOptions: { label: string; value: string }[];
  onRoleChange: (username: string, roles: string) => void;
  onEdit: (user: User) => void; 
  onSaveAll: () => void;
}

const ManageUserTable: React.FC<ManageUserTableProps> = ({ 
  users, 
  roleOptions, 
  setUsers,
  onRoleChange, 
  onUserStatusChange,
  onSaveAll,
  onEdit,
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [userToDelete, setUserToDelete] = useState<{ id: string, currentStatus: string } | null>(null);

  const confirmDelete = (id: string, currentStatus: string) => {
    setUserToDelete({ id, currentStatus });
    setShowDelete(true);
  };

  const handleDelete = async () => {
    if (userToDelete) {
      try {
        const newStatus = userToDelete.currentStatus === 'active' ? 'inactive' : 'active';
        await onUserStatusChange(Number(userToDelete.id), newStatus);
      } catch (err) {
        console.error(err);
        toast.error('Error updating user status');
      } finally {
        setShowDelete(false);
        setUserToDelete(null);
      }
    }
  };

  return (
    <>
      <div className="table-container mt-3">
        <div className="table-responsive">
          <table className="table">
            <thead className="TableHeader">
              <tr>
                <th className="p-3 w-10">First name</th>
                <th className="p-3 w-8">Last name</th>
                <th className="p-3 w-22">Email</th>
                <th className="p-3 w-30">Roles</th>
                <th className="p-3 w-20">Knowledge hubs</th>
                <th className="p-3 w-10">Crews</th>
                <th className="p-3">Actions</th>
              </tr>
            </thead>    
            <tbody>
              {users.map((user) => (
                <ManageUserRow
                  key={user.id}
                  user={user}   
                  roleOptions={roleOptions}
                  onRoleChange={onRoleChange}
                  onEdit={onEdit}
                  onDelete={confirmDelete}
                  setUsers={setUsers}
                />
              ))}
            </tbody>
          </table>
          <ConfirmDialog
            show={showDelete}
            onHide={() => setShowDelete(false)}
            onConfirm={handleDelete}
            title="Confirm "
            body={`Are you sure you want to ${userToDelete?.currentStatus === 'active' ? 'archive' : 'activate'} this user?`}
            confirmText={userToDelete?.currentStatus === 'active' ? 'Archive' : 'Activate'}
          />
        </div>
        <div className="d-flex justify-content-end mt-3">
          <button className="btn SaveBtn m-0 mt-3" onClick={onSaveAll}>
            Save
          </button>
        </div>
      </div>
    </>
  )
}

export default ManageUserTable;